import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import TagManager from 'react-gtm-module'

/* Google Tag Manager */
const tagManagerArgs = {
    gtmId: 'GTM-TKND5L4'
}

TagManager.initialize(tagManagerArgs)

TagManager.dataLayer({
    dataLayer: {
        event: 'page_view',
        pagePath: window.location.pathname
    }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
